<template>
  <div class="teacher-fields" style="width:100%;">
    <h2>{{ $t("user.roles.teacher.title") }}</h2>
    <v-flex xs12>
      <v-checkbox
        v-model="data.relation.is_admin"
        :disabled="!canEdit"
        :label="$t('user.roles.teacher.admin')"
      />
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    canEdit: Boolean,
    submitting: Boolean
  },
  data() {
    return {
      initTeacher: null,
      teacher: null
    };
  },
  computed: {
    // TODO: Use an adapter by using vuex to prevent duplicated code
    mergedUser: function() {
      // Create a copy of the user to avoid altering it
      var adaptedUser = JSON.parse(JSON.stringify(this.data));
      if (adaptedUser.relation) {
        adaptedUser.teacher = adaptedUser.relation;
        delete adaptedUser.relation;
      }
      return adaptedUser;
    }
  },
  watch: {
    teacher: {
      handler() {
        this.updateParent();
      },
      deep: true
    },
    submitting: {
      handler(val) {
        if (val) {
          this.submit();
        }
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.teacher = this.data.relation;
      this.updateInitTeacher();
    });
  },
  methods: {
    /**
     * Tells the parent if fields data have changed.
     */
    updateParent() {
      const changed = !(this.teacher.is_admin == this.initTeacher.is_admin);
      this.$emit("dataChanged", changed);
    },

    /**
     * Updates the reference teacher object to compare for changes.
     */
    updateInitTeacher() {
      const teacher = this.data.relation;
      this.initTeacher = {
        is_admin: teacher.is_admin
      };
    },

    /**
     * Submit the form to the backend.
     */
    submit() {
      this.$store
        .dispatch("user/update", this.mergedUser)
        .then(response => this.successUpdate(response))
        .catch(error => this.errorUpdate(error));
    },

    /**
     * If the submission has been successful.
     */
    // eslint-disable-next-line no-unused-vars
    successUpdate(response) {
      this.updateInitTeacher();
      this.$emit("submitted", {
        type: "success",
        message: this.$t("app.actions.success.update")
      });
    },

    /**
     * If an error occurred while submitting the form.
     */
    errorUpdate(error) {
      if (process.env.NODE_ENV !== "production") {
        console.log(error);
      }
      this.$emit("submitted", {
        type: "error",
        message: this.$t("app.actions.failed.update")
      });
    }
  }
};
</script>
